@if ({ isDisabled: disabled | async }; as data) {
  <button
    type="button"
    [disabled]="data.isDisabled ? 'disabled' : undefined"
    class="aa-btn"
    [class.masked]="data.isDisabled === null"
    [ngClass]="getClassNames()"
    (click)="onClick()"
    [style.width.px]="btnWidth"
    >
    <span>
      <i class="fad fa-fw" aria-hidden="true"></i>&nbsp;
      {{ btnText }}&nbsp;
      @if (data.isDisabled === null) {
        <i class="fad fa-fw fa-spinner fa-spin" aria-hidden="true"></i>
      }
      @if (data.isDisabled !== null) {
        <i class="fad fa-fw" aria-hidden="true"></i>
      }
    </span>
  </button>
}
